<template>
  <el-dialog
    :model-value="visible"
    :close-on-click-modal="false"
    :title="$t('main_header_change_SYS_password')"
    width="500px"
    @close="cancel"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="80px"
      size="small"
      style="height: 340px;"
    >
      <el-form-item :label="$t('main_header_change_name')">
        <span>{{ userInfo.name }}</span>
      </el-form-item>
      <el-form-item :label="$t('main_header_change_Work_number')">
        <span>{{ userInfo.uid }}</span>
      </el-form-item>
      <el-form-item
        prop="OldPassword"
        :label="$t('main_header_old_password')"
      >
        <el-input
          v-model="form.OldPassword"
          :type="isShow ? 'text' : 'password'"
          :placeholder="$t('main_header_old_password_placeholder')"
          autocomplete="new-password"
        >
          <template #suffix>
            <i
              :class="['toggle-view', 'iconfont', isShow ? 'el-icon-view' : 'el-icon-unview']"
              @click="isShow=!isShow"
            ></i>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item
        prop="NewPassword"
        :label="$t('main_header_new_password')"
      >
        <el-input
          v-model="form.NewPassword"
          type="password"
          :placeholder="$t('main_header_new_password_placeholder')"
          autocomplete="new-password"
        ></el-input>
      </el-form-item>
      <el-form-item
        prop="ConfirmPassword"
        :label="$t('main_header_confirm_password')"
      >
        <el-input
          v-model="form.ConfirmPassword"
          type="password"
          :placeholder="$t('main_header_confirm_password_placeholder')"
          autocomplete="new-password"
        ></el-input>
        <ul v-if="isCheckPassword">
          <template v-for="(item, index) in messageObj" :key="index">
            <li
              v-if="(index !== 3 && index !== 4) || !item.status"
              style="font-size: 12px; height: 18px; line-height: 18px;"
            >
              <span :class="[item.status ? 'success' : 'error']">
                {{ item.message }}
                <i :class="[item.status ? 'el-icon-success' : 'el-icon-error']"></i>
              </span>
            </li>
          </template>
        </ul>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="cancel">{{ $t('main_header_cancel') }}</el-button>
      <el-button :loading="isLoading" type="primary" @click="submit">{{ $t('main_header_confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { changePassword } from '@/services/accounts'
import { mapState } from 'vuex'

export default {
  name: 'LayoutChangePasswordDialog',
  props: {
    visible: Boolean
  },
  computed: {
    ...mapState('user', ['userInfo'])
  },
  emits: ['cancel'],
  data () {
    // const confirmValidate = (rule, value, callback) => {
    //   if (value !== this.form.NewPassword) {
    //     callback(new Error('两次输入的密码不同'))
    //   }
    //   callback()
    // }

    // const newValidate = (rule, value, callback) => {
    //   if (value === this.form.OldPassword) {
    //     callback(new Error('新密码不能与旧密码相同'))
    //   }
    //   const pwdRegex1 = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])') // 包含字母、数字和特殊字符
    //   const pwdRegex2 = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])') // 包含大小写字母，特殊字符
    //   const pwdRegex3 = new RegExp('(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])') // 包含大小写字母，数字
    //   if (!pwdRegex1.test(value) && !pwdRegex2.test(value) && !pwdRegex3.test(value)) {
    //     callback(new Error('必须包含大小写字母，数字，特殊符号，满足其中3种'))
    //   }
    //   const pwdRegNum = /^(?!.*(\d)\1{2}).*$/
    //   const pwdFuncNum = () => {
    //     const arr = value.split('')
    //     for (let i = 0; i < arr.length - 1; i++) {
    //       const numStr = value.substr(i, 3)
    //       if (!isNaN(numStr) && Number(numStr) > 0) {
    //         const numArr = numStr.split('')
    //         const firstNum = Number(numArr[0])
    //         const secondNum = Number(numArr[1])
    //         const thirdNum = Number(numArr[2])
    //         if (secondNum - firstNum === 1 && thirdNum - secondNum === 1) {
    //           return false
    //         }
    //       }
    //     }
    //     return true
    //   }
    //   // const isLen = value.length >= 8 && value.length <= 24
    //   // const isMatchType = !pwdRegex1.test(value) && !pwdRegex2.test(value) && !pwdRegex3.test(value)
    //   const isMatchNum = !pwdRegNum.exec(value) || !pwdFuncNum()
    //   if (isMatchNum) {
    //     callback(new Error('不允许有连续或重复的3位以上的数字'))
    //   }
    //   callback()
    // }

    return {
      form: {
        OldPassword: '',
        NewPassword: '',
        ConfirmPassword: ''
      },
      rules: {
        OldPassword: [
          { required: true, message: this.$t('main_header_old_password_placeholder'), trigger: 'blur' }
        ],
        NewPassword: [
          { required: true, message: this.$t('main_header_new_password_placeholder'), trigger: 'blur' }
          // { min: 8, max: 24, message: '请输入长度 8-24 位的密码', trigger: 'blur' },
          // { validator: newValidate, trigger: 'blur' }
        ],
        ConfirmPassword: [
          { required: true, message: this.$t('main_header_confirm_password_placeholder'), trigger: 'blur' }
          // { validator: confirmValidate, trigger: 'blur' }
        ]
      },
      isShow: false,
      isLoading: false,
      isCheckPassword: false,
      messageObj: [
        {
          status: false,
          message: this.$t('main_header_messageObj_length')
        },
        {
          status: false,
          message: this.$t('main_header_messageObj_three_condition')
        },
        {
          status: false,
          message: this.$t('main_header_messageObj_no_repeat')
        },
        {
          status: false,
          message: this.$t('main_header_messageObj_old_new_different')
        },
        {
          status: false,
          message: this.$t('main_header_messageObj_twice_different')
        }
      ]
    }
  },
  methods: {
    cancel () {
      this.form = {
        OldPassword: '',
        NewPassword: '',
        ConfirmPassword: ''
      }
      this.isShow = false
      this.isLoading = false
      this.$refs.form.clearValidate()
      this.$emit('cancel')
    },
    checkPassword (value, confirmValue, oldValue) {
      // 判断条件一 长度
      const isLen = value.length >= 8 && value.length <= 16
      this.messageObj[0].status = isLen

      // 判断条件二 3种格式
      const pwdRegex1 = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])') // 包含字母、数字和特殊字符
      const pwdRegex2 = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])') // 包含大小写字母，特殊字符
      const pwdRegex3 = new RegExp('(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])') // 包含大小写字母，数字
      const isType = pwdRegex1.test(value) || pwdRegex2.test(value) || pwdRegex3.test(value)
      this.messageObj[1].status = isType

      // 判断条件三 连续数字
      const pwdRegNum = /^(?!.*(\d)\1{2}).*$/
      const pwdFuncNum = () => {
        const arr = value.split('')
        for (let i = 0; i < arr.length - 1; i++) {
          const numStr = value.substr(i, 3)
          if (!isNaN(numStr) && Number(numStr) > 0) {
            const numArr = numStr.split('')
            const firstNum = Number(numArr[0])
            const secondNum = Number(numArr[1])
            const thirdNum = Number(numArr[2])
            if (secondNum - firstNum === 1 && thirdNum - secondNum === 1) {
              return false
            }
          }
        }
        return true
      }
      const isMatchNum = (pwdRegNum.exec(value) && pwdFuncNum())
      this.messageObj[2].status = isMatchNum

      // 判断新旧密码是否相同
      this.messageObj[3].status = value !== oldValue

      // 判断两次输入新密码是否相同
      const isSame = value === confirmValue
      this.messageObj[4].status = isSame

      this.isCheckPassword = this.messageObj.some(item => !item.status)
    },
    async submit () {
      const query = JSON.parse(JSON.stringify(this.form))
      Reflect.deleteProperty(query, 'ConfirmPassword')
      try {
        await this.$refs.form.validate()
        const { OldPassword, NewPassword, ConfirmPassword } = this.form
        this.checkPassword(NewPassword, ConfirmPassword, OldPassword)
        if (!this.isCheckPassword) {
          this.isLoading = true
          await changePassword(query)
          this.$emit('cancel')
          this.$message.success(this.$t('main_header_change_success'))
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toggle-view {
  cursor: pointer;
  font-size: 20px;

  &:hover {
    opacity: .5;
  }
}

.success {
  color: #1ABC82;
}

.error {
  color: #F56C6C;
}

:deep(.el-input__icon ) {
  display: none;
}
</style>
